module.exports = __webpack_public_path__ + "static/media/breath-nav.9cb5936e.png";